import { Profile, Benefit, Question } from '@td/membersupport';
import { authToken, teladocApi } from '@td/api';
import { get } from 'lodash';
import FIND_MEMBER from './queries/find-member.js';
import {
  isMemberRestricted,
  hasfullTdMembersAccess,
  hasLimitedPhiAccess,
  maskData,
  maskedInfo
} from '../Utils';

export const loadSecurityQuestions = () => {
  return teladocApi.get('/v4/security_questions', {}, authToken.get()).then(questions => {
    return questions;
  })
}

export const loadMembersSecurityQuestions = (memberId) => {
  return teladocApi.get(`/v4/members/${memberId}/security_questions`).then(questions => {
    return questions;
  })
}

const loadHealthPlanIds = (memberId) => {
  return teladocApi.get(`/v4/members/${memberId}/member_payer_relations`).then(({data}) => {
    return get(data, 'member_payer_relations', []).map( p => p.source_health_plan_id )
  })
}


export const mapSecurityQuestions = (memberId) => {
  let result = {};
  return Promise.all([loadSecurityQuestions(), loadMembersSecurityQuestions(memberId)]).then(responses => {

    const safeEmployeeAnswers = get(responses, '[1].data.security_questions', []);
    const safeSecurityQuestions = get(responses, '[0].data.security_questions', []);
    const employeeAnswers = safeEmployeeAnswers.map(q => q.question_id);
    const securityQuestions = safeSecurityQuestions.map(q => q.question_id);
    const answredQuestionIds = _.intersectionWith(securityQuestions, employeeAnswers, _.isEqual);
    safeSecurityQuestions.map(question => {
      if (answredQuestionIds.includes(question.question_id)) {
        result[question.question_id] = question;
      }
    })

    safeEmployeeAnswers.map(question => {
      if (answredQuestionIds.includes(question.question_id)) {
        result[question.question_id] = Object.assign({}, result[question.question_id], question);
      }
    })

    return result;
  })
}

export const loadMembersMHD = (memberId) => {
  return teladocApi.get(`/v4/members/${memberId}/mhd_status`).then(mhd => {
    return mhd;
  })
}

export const loadProfile = (memberId, groupId, client) => {
  return client
    .query({
      variables: {id: memberId},
      query: FIND_MEMBER,
    })
    .then(result => {

      return Promise.all([mapSecurityQuestions(memberId),loadMembersMHD(memberId)]).then(results => {
        let membersQuestionsList = [];
        let securityQuestions = get(results, '[0]', {});
        let updatedDate = get(results, '[1].data.mhd_updated_at', 'No MHD');
        _.forIn(securityQuestions, (response, k) => {
          let q = Question({
            questionId: response.question_id,
            securityQuestion: get(response, 'security_question', ''),
            securityResponse: get(response, 'security_response', ''),
          })

          membersQuestionsList.push(q);
        })

        const restricted = isMemberRestricted(groupId.toString().split());
        const hasFullAccess = hasfullTdMembersAccess(restricted);

        const theProfile = Profile({
          lastMhdUpdate: maskData(updatedDate, hasLimitedPhiAccess(restricted)),
          benefits: get(result, 'data.member.mrns', []).length ?
            result.data.member.mnrs.map( benefit => Benefit({
              sponsor: get(benefit, 'group.name'),
              isActive: maskData(get(benefit, 'isActive'), hasFullAccess),
              coverageStartDate: maskData(get(benefit, 'coverageStartDate'), hasFullAccess),
              coverageEndDate: maskData(get(benefit, 'coverageEndDate'), hasFullAccess),
              memberId: benefit.mrnId,
              classification: benefit.isPrimary ? 'Primary' : 'Dependent',
              products: maskData((get(benefit, 'serviceSpecialties') || []).map( s => s.name ), hasFullAccess),
              healthPlanId: maskData(get(benefit, 'sourceHealthPlanId') || get(benefit, 'sourceMrnId', 'N/A'), hasFullAccess),
              registrationGroupCode: maskData(get(benefit, 'group.registrationCode'), hasFullAccess),
            })) : [],
          securityQuestions: hasFullAccess ? membersQuestionsList : maskedInfo,
        });
        return theProfile;
      })
    })
    .catch( err => console.error(err));
}

window.loadProfile = loadProfile;
window.loadMembersMHD = loadMembersMHD;
